// extracted by mini-css-extract-plugin
export default {"para":"styles_para__3x-Jm","Wrapper":"styles_Wrapper__ns0Pd","Main":"styles_Main__ob5XF"};